import useTokens from './use-tokens';
import { InternalAxiosRequestConfig } from 'axios';

declare module 'axios' {
  export interface AxiosRequestConfig {
    noAuth?: boolean;
  }
}

/**
 * Request Interceptor adding authorization header to requests
 */
export const requestInterceptor = async (request: InternalAxiosRequestConfig) => {
  const tokensStore = useTokens();

  if (!request.noAuth) {
    const tokens = await tokensStore.getValidTokens();

    if (tokens) {
      request.headers.Authorization = `Bearer ${tokens.accessToken}`;
    }
  }

  return request;
};
